/* AutoChimp vehicle finder (Make -> Model -> Year range). Moved out of snippets/ac-finder-widget.liquid
   into this cached asset, 20 Sep 2026 speed pass (v29). Initialises every [data-ac-finder] on the page;
   per-widget settings come from data-ac-fallback / data-ac-base; data from the JSON scripts next to it. */
(function () {
  if (window.ACFinder) return;
  function initFinder(root) {
    if (!root || root.__acFinder) return;
    root.__acFinder = true;
    var uid = root.getAttribute('data-ac-finder');
    var raw = document.querySelector('[data-ac-finder-lookup="' + uid + '"]');
    if (!raw) return;
    var data; try { data = JSON.parse(raw.textContent); } catch (e) { console.warn('ac-finder: lookup JSON invalid', e); return; }
    var mk = root.querySelector('[data-ac-make]'), md = root.querySelector('[data-ac-model]'), yr = root.querySelector('[data-ac-year]'), go = root.querySelector('[data-ac-submit]');
    var note = root.querySelector('[data-ac-note]');
    var fallback = root.getAttribute('data-ac-fallback') || '';
    var base = root.getAttribute('data-ac-base') || '/collections/autochimp-catalog';
    var ranges = [];

    /* 21 Sep 2026 (Daniel): results land sorted PRICE HIGH TO LOW, not the collection's default
       "best selling". Measured live: best selling put a screwdriver, sealing tape and a mounting
       bracket above every universal kit, and put harnesses above all six LC70 kits, because the
       cheap components outsell the kits. Price order puts the bundle kits first on BOTH paths.
       Delete AC_SORT (and its two uses below) to go back to the collection's own order. */
    var AC_SORT = 'sort_by=price-descending';

    /* Universal option: last in the Make list, needs no model or year. */
    var UNIVERSAL = '__universal';
    var UNIVERSAL_LABEL = 'Other vehicle / Universal';
    var UNIVERSAL_MAKE = 'Universal';   /* value of custom.vehicle_make_structured on fit-anything products */
    var UNIVERSAL_NOTE = 'Shows our universal products: cameras, cables, connectors and tools that suit any vehicle.';

    /* Silent year overrides (snippets/ac-finder-questions.liquid). Any problem = no overrides. */
    var overrides = null;
    var oraw = document.querySelector('[data-ac-finder-years="' + uid + '"]');
    if (oraw) { try { overrides = JSON.parse(oraw.textContent).years || null; } catch (e) { console.warn('ac-finder: year overrides invalid, ignored', e); } }
    function yearsFor(label, fallbackYears) {
      var o = overrides && overrides[mk.value] && overrides[mk.value][md.value] && overrides[mk.value][md.value][label];
      return (Array.isArray(o) && o.length) ? o : fallbackYears;
    }

    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
    function isUniversal() { return mk.value === UNIVERSAL; }
    function sync() { go.disabled = !(isUniversal() || md.value); }
    function setNote(t) { if (!note) return; note.textContent = t || ''; note.hidden = !t; }

    function fillIndexed(sel, items, ph) {
      sel.innerHTML = '<option value="">' + ph + '</option>' + items.map(function (i, n) {
        return '<option value="' + n + '">' + esc(i) + '</option>';
      }).join('');
      sel.disabled = !items.length;
    }
    function fillNamed(sel, items, ph) {
      sel.innerHTML = '<option value="">' + ph + '</option>' + items.map(function (i) {
        return '<option value="' + esc(i) + '">' + esc(i) + '</option>';
      }).join('');
      sel.disabled = !items.length;
    }
    fillNamed(mk, Object.keys(data), 'Make');
    mk.insertAdjacentHTML('beforeend', '<option value="' + UNIVERSAL + '">' + esc(UNIVERSAL_LABEL) + '</option>');

    mk.addEventListener('change', function () {
      fillNamed(md, (mk.value && data[mk.value]) ? Object.keys(data[mk.value]) : [], 'Model');
      ranges = []; fillIndexed(yr, [], 'Year');
      setNote(isUniversal() ? UNIVERSAL_NOTE : '');
      sync();
    });
    md.addEventListener('change', function () {
      ranges = (mk.value && md.value && data[mk.value] && data[mk.value][md.value]) || [];
      fillIndexed(yr, ranges.map(function (r) { return r.l; }), 'Year');
      sync();
    });
    yr.addEventListener('change', sync);

    root.querySelector('[data-ac-finder-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      if (isUniversal()) {
        window.location.href = base + '?filter.p.m.custom.vehicle_make_structured=' + encodeURIComponent(UNIVERSAL_MAKE) + '&' + AC_SORT;
        return;
      }
      if (!mk.value || !md.value) { if (fallback) window.location.href = fallback; return; }
      var p = [
        'filter.p.m.custom.vehicle_make_structured=' + encodeURIComponent(mk.value),
        'filter.p.m.custom.vehicle_models_structured=' + encodeURIComponent(md.value)
      ];
      var pick = yr.value === '' ? null : ranges[parseInt(yr.value, 10)];
      var years = pick ? yearsFor(pick.l, pick.y) : null;
      if (years) {
        years.forEach(function (y) { p.push('filter.p.m.custom.vehicle_years_structured=' + encodeURIComponent(y)); });
      }
      p.push(AC_SORT);
      window.location.href = base + '?' + p.join('&');
    });
  }
  function initAll() { document.querySelectorAll('[data-ac-finder]').forEach(initFinder); }
  window.ACFinder = { init: initAll };
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();
